<template>
  <v-flex 
    class="text-center"
    :class="{'login-form': $vuetify.breakpoint.lgAndUp}"
  >
    <v-card flat class="px-4 py-8" style="background-color: transparent;">
      <v-alert
        v-if="errors_exist"
        dismissible
        type="error"
        class="rounded-0"
      >
        {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
        <ul v-if="errors">
          <div v-for="(error, index) in errors">
            <li :key="index">{{ error[0] }}</li>
          </div>
        </ul>
      </v-alert>
      <v-card-text>
        <v-img
          alt="Vuetify Logo"
          src="@/assets/agriportal-logo-v2.png"
          lazy-src="@/assets/NoImage.jpg"
          class="mx-auto"
          width="150"
        />
        <v-form
          class="mt-12"
          v-model="isValid" 
          @submit.prevent="loginSubmit"
        >
          <v-text-field 
            v-model="form.username"
            label="Tên tài khoản" 
            type="email"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-text-field 
            v-model="form.password"  
            label="Mật khẩu" 
            :type="showp ? 'text' : 'password'"
            :append-icon="showp ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showp = !showp"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-btn
            v-if="options.isLoggingIn" 
            large 
            class="mb-4" 
            color="primary"             
            block="block" 
            type="submit" 
            :loading="loading"
            :disabled="!isValid"
          >Đăng Nhập</v-btn>
          <!-- <div class="text-body-2">
            Chưa có tài khoản?
            <a href="register">
              Đăng ký
            </a>
          </div> -->
        </v-form>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    name: "login",
    data() {
      return {
        showp: false,
        form: {
          username: null,
          password: null,
        },
        isValid: true,
        loading: false,
        options: {
          isLoggingIn: true,
          shouldStayLoggedIn: true,
        },
        errors_exist: false,
        errors: [],
      };
    },
    methods: {
      ...mapActions([
        'login'
      ]),
      loginSubmit () {
        const app=this;
        app.loading=true;
        app.errors_exist=false;
        app.errors=[];
        app.login({
          email: app.form.username,
          password: app.form.password
        })
          .then((res) => {
            app.loading=false;
            // app.$router.go(-1);
            app.$router.push({name: 'Dashboard'});
          })
          .catch(error => {
            app.loading=false;
            app.errors_exist = true;
            if([422, 401].includes(error.response.status)) {
              app.errors = error.response.data || {};
            }
          })
      }
    }
  };
</script>
<style>
  .login-form {
    max-width: 470px;
    margin: 0 auto;
  }
</style>